import { render, staticRenderFns } from "./RealtimeSubtitles.vue?vue&type=template&id=3809d2f6&scoped=true"
import script from "./RealtimeSubtitles.vue?vue&type=script&lang=js"
export * from "./RealtimeSubtitles.vue?vue&type=script&lang=js"
import style0 from "./RealtimeSubtitles.vue?vue&type=style&index=0&id=3809d2f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3809d2f6",
  null
  
)

export default component.exports